//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import slugify from 'slugify';

export default {
  props: {
    
  },
  computed: {
      numStops() {
          return this.lodash.reduce(this.days, function(sum, n) {
            return sum + n.stops.length;
          }, 0);
      },
      flatStops() {
          return this.lodash.flatMap(this.days, (day) => {
              return day.stops;
          })
      }
  },
  watch: {

  },
  components: {

  },
  data() {
    return { 
      
        details: details,
        days: days,
        stop: 0,
        partner: partner,
        totalStops: 0,
        allTours: allTours
     
    }
  },
  mounted() {

     

  },
  methods: {

   
       getTitle(stop) {
          let url_title = stop.type == 'venue' ? stop.venue : stop.event;
          let url_parts = url_title.split('0');

         
      },
      getStopIndex(stop) {
        
        let idx = this.lodash.findIndex( this.flatStops, (o) => {
            return o == stop;
        } );

        return idx+1;

      },
      getStopClass(stop) {
        
        let idx = this.lodash.findIndex( this.flatStops, (o) => {
            return o == stop;
        } );

        return idx % 2 === 0 ? 'left' : 'right';

      }
    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Tour.vue